// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export const highContrastHeaderClassName = 'awsui-context-content-header';
//# sourceMappingURL=content-header-utils.js.map